module.exports = __webpack_public_path__ + "img/case2-1.fe477603.png";